import React, { Component } from 'react';
import FiltroEscola from '../acompanhamento/filtros/FiltroEscola';
import FiltroPeriodoSimulado from '../acompanhamento/filtros/FiltroPeriodoSimulado';
import FiltroSerieTurmaAluno from '../acompanhamento/filtros/FiltroSerieTurmaAluno';

var isEqual = require('lodash.isequal');

class Filtro extends Component {
    constructor(props) {
        super(props);

        this.filtroSerieTurmaAlunoRef = React.createRef()
        this.filtroPeriodoSimuladoRef = React.createRef()

        this.state = {
            // Filtro pendente
            filtroPendente: false,

            //Filtro Escola
            escolaSelecionada: {},

            //Filtro serie turma aluno
            serieSelecionada: undefined,
            turmasSelecionadas: undefined,
            alunoSelecionado: undefined,
            descricaoAluno: "",
            descricaoSerieTurma: "",

            //Filtro PeriosoSimulado
            periodoSelecionado: undefined,
            simuladoSelecionado: undefined,
            descricaoPeriodoSimulado: ""
        }


        this.onChangeEscola = this.onChangeEscola.bind(this);
        this.onChangeSerieTurmaAluno = this.onChangeSerieTurmaAluno.bind(this);
        this.onChangePeriodoSimulado = this.onChangePeriodoSimulado.bind(this);
        this.onClickAplicarFiltros = this.onClickAplicarFiltros.bind(this);
    }

    onChangeEscola(item) {
        // reinicia todo o state do componente
        this.filtroSerieTurmaAlunoRef.current.reset();

        this.setState({
            filtroPendente: this.state.filtroPendente,
            escolaSelecionada: item,
            serieSelecionada: undefined,
            turmasSelecionadas: undefined,
            alunoSelecionado: undefined,
            descricaoAluno: '',
            descricaoSerieTurma: '',
            periodoSelecionado: undefined,
            simuladoSelecionado: undefined,
            descricaoPeriodoSimulado: ''
        });
    }

    onChangePeriodoSimulado(periodo, simulado, descricao) {
        //console.log(periodo, simulado);
        this.setState({ periodoSelecionado: periodo, simuladoSelecionado: simulado, descricaoPeriodoSimulado: descricao });
    }

    onChangeSerieTurmaAluno(serie, turmas, aluno, descricaoAluno, descricaoSerieTurma){
        this.setState({ serieSelecionada: serie, turmasSelecionadas: turmas, alunoSelecionado: aluno, descricaoAluno: descricaoAluno, descricaoSerieTurma: descricaoSerieTurma });
    }

    onClickAplicarFiltros(){
        window.scrollTo(0, 0);
        if(Object.keys(this.state.escolaSelecionada).length===0 ) {
            this.setState({ filtroPendente: true });
        }
        else {
            if(this.props.onClickAplicar){
                if(this.props.isMobile && this.props.onClickClose) {
                    this.props.onClickClose();
                }
                this.props.onClickAplicar(this.state);
            }
        }
    }

    componentDidUpdate(prevProps) {
      // Typical usage (don't forget to compare props):
      if(!isEqual(this.props.selected, prevProps.selected)){
        if(this.props.selected && Object.keys(this.props.selected).length >0 && this.props.selected.selectedSchool && Object.keys(this.props.selected.selectedSchool).length >0) {
          this.setState({ escolaSelecionada: this.props.selected.selectedSchool });
        }
        if(this.props.selected.selectedGrade) {
          this.setState({ serieSelecionada: this.props.selected.selectedGrade });
        }
      }
    }

    render() {
        return (<div className={"edb-padding " + this.props.className}>

            <button
                className="edb-block edb-margin-bottom edb-button adap-green edb-round edb-padding-small"
                onClick={this.onClickAplicarFiltros}>Aplicar filtros</button>
            {this.state.filtroPendente && <div className="edb-small edb-margin-small-bottom edb-text-bold adap-text-red">* Selecione os itens destacados</div>}


            <FiltroEscola
                className="edb-margin-bottom"
                filtroRequerido={this.state.filtroPendente && Object.keys(this.state.escolaSelecionada).length===0 }
                idEscola={this.state.escolaSelecionada.idEntitySchool}
                onChange={this.onChangeEscola} />

            <FiltroSerieTurmaAluno
                ref={this.filtroSerieTurmaAlunoRef}
                className="edb-margin-bottom"
                idEscola={this.state.escolaSelecionada.idEntitySchool}
                idSerie={this.state.serieSelecionada}
                esconderAlunos={false}
                marcarApenasAlunos={false}
                onChange={this.onChangeSerieTurmaAluno}/>

            <FiltroPeriodoSimulado
                ref={this.filtroPeriodoSimuladoRef}
                className="edb-margin-bottom"
                idEscola={this.state.escolaSelecionada.idEntitySchool}
                onChange={this.onChangePeriodoSimulado} />

            <button
                className="edb-block edb-margin-bottom edb-button adap-green edb-round edb-padding-small"
                onClick={this.onClickAplicarFiltros}>Aplicar filtros</button>
        </div>);
    }
}

export default Filtro;